import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router= new Router({
  routes: [
    {   
      path: '/admin',
      name: '/admin/login',
      meta:{
        title:'运营后台管理系统'
      },
      component:(resolve) => require(['@/components/login.vue'], resolve),
    },
    {   
      path: '/admin/public',
      name: '/admin/public',
      meta:{
        title:'运营后台管理系统'
      },
      component:(resolve) => require(['@/components/index.vue'], resolve),
      children:[
        {   
          path: '/admin/video/videoList',
          name: '/admin/video/videoList',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/video/videoList.vue'], resolve),
        },
        {   
          path: '/admin/video/list',
          name: '/admin/video/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/video/list.vue'], resolve),
        },
         {   
          path: '/admin/video/moreVideoList',
          name: '/admin/video/moreVideoList',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/video/moreVideoList.vue'], resolve),
        },
        {   
          path: '/admin/classify/list',
          name: '/admin/classify/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/classify/list.vue'], resolve),
        },
        {   
          path: '/admin/suggestion/list',
          name: '/admin/suggestion/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/suggestion/list.vue'], resolve),
        },
        {   
          path: '/admin/comment/list',
          name: '/admin/comment/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/comment/list.vue'], resolve),
        },
        {
          path: '/admin/siteStats/list',
          name: '/admin/siteStats/list',
          meta:{
            title:'数据统计'
          },
          component:(resolve) => require(['@/components/siteStats/list.vue'], resolve),
        },
        {
          path: '/admin/videoAdmin/list',
          name: '/admin/videoAdmin/list',
          meta:{
            title:'视频管理'
          },
          component:(resolve) => require(['@/components/videoAdmin/list.vue'], resolve),
        },
        {
          path: '/admin/videoAdmin/category',
          name: '/admin/videoAdmin/category',
          meta:{
            title:'视频分类'
          },
          component:(resolve) => require(['@/components/videoAdmin/category.vue'], resolve),
        },
        {
          path: '/admin/shortStory/list',
          name: '/admin/shortStory/list',
          meta:{
            title:'短篇管理'
          },
          component:(resolve) => require(['@/components/shortStory/list.vue'], resolve),
        },
        {
          path: '/admin/shortStory/category',
          name: '/admin/shortStory/category',
          meta:{
            title:'短篇分类'
          },
          component:(resolve) => require(['@/components/shortStory/category.vue'], resolve),
        },
        {
          path: '/admin/shortStory/comment',
          name: '/admin/shortStory/comment',
          meta:{
            title:'短篇评论'
          },
          component:(resolve) => require(['@/components/shortStory/comment.vue'], resolve),
        },






        {   
          path: '/admin/show',
          name: '/admin/show',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/show.vue'], resolve),
        },
        {   
          path: '/admin/shop/list',
          name: '/admin/shop/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/shop/shopList.vue'], resolve),
        },
        {   
          path: '/admin/shop/classify',
          name: '/admin/shop/classify',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/shop/shopClassify.vue'], resolve),
        },
        {   
          path: '/admin/shop/info',
          name: '/admin/shop/info',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/shop/shopInfo.vue'], resolve),
        },
        {   
          path: '/admin/coupon/classify',
          name: '/admin/coupon/classify',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/coupon/classify.vue'], resolve),
        },
        {   
          path: '/admin/coupon/list',
          name: '/admin/coupon/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/coupon/list.vue'], resolve),
        },
        {   
          path: '/admin/banner/index',
          name: '/admin/banner/index',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/banner/index.vue'], resolve),
        },
        {   
          path: '/admin/apply/flux',
          name: '/admin/apply/flux',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/flux.vue'], resolve),
        },
        {   
          path: '/admin/apply/await',
          name: '/admin/apply/await',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/await.vue'], resolve),
        },
        {   
          path: '/admin/apply/awaitKj',
          name: '/admin/apply/awaitKj',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/awaitKj.vue'], resolve),
        },
        {   
          path: '/admin/apply/lottery',
          name: '/admin/apply/lottery',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/lottery.vue'], resolve),
        },
        {   
          path: '/admin/apply/evaluate',
          name: '/admin/apply/evaluate',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/evaluate.vue'], resolve),
        },
        {   
          path: '/admin/apply/return',
          name: '/admin/apply/return',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/return.vue'], resolve),
        },
        {   
          path: '/admin/apply/finish',
          name: '/admin/apply/finish',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/apply/finish.vue'], resolve),
        },
        {   
          path: '/admin/user/list',
          name: '/admin/user/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/user/list.vue'], resolve),
        },
        {   
          path: '/admin/user/tb',
          name: '/admin/user/tb',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/user/tb.vue'], resolve),
        },
        {   
          path: '/admin/user/zfb',
          name: '/admin/user/zfb',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/user/zfb.vue'], resolve),
        },
        {   
          path: '/admin/user/realName',
          name: '/admin/user/realName',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/user/realName.vue'], resolve),
        },
        {   
          path: '/admin/user/shopHobby',
          name: '/admin/user/shopHobby',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/user/shopHobby.vue'], resolve),
        },
        {   
          path: '/admin/user/yh',
          name: '/admin/user/yh',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/user/yh.vue'], resolve),
        },
        {   
          path: '/admin/invite/list',
          name: '/admin/invite/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/invite/list.vue'], resolve),
        },
        {   
          path: '/admin/invite/stream',
          name: '/admin/invite/stream',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/invite/stream.vue'], resolve),
        },
        {   
          path: '/admin/invite/follower',
          name: '/admin/invite/follower',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/invite/follower.vue'], resolve),
        },
        {   
          path: '/admin/finance/list',
          name: '/admin/finance/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/finance/list.vue'], resolve),
        },
        {   
          path: '/admin/finance/business',
          name: '/admin/finance/business',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/finance/business.vue'], resolve),
        },
        {   
          path: '/admin/finance/account',
          name: '/admin/finance/account',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/finance/account.vue'], resolve),
        },
        {   
          path: '/admin/business/list',
          name: '/admin/business/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/business/list.vue'], resolve),
        },
        {   
          path: '/admin/role/list',
          name: '/admin/role/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/role/list.vue'], resolve),
        },
        {   
          path: '/admin/flux/list',
          name: '/admin/flux/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/flux/list.vue'], resolve),
        },
        {   
          path: '/admin/flux/detail',
          name: '/admin/flux/detail',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/flux/detail.vue'], resolve),
        },
        {   
          path: '/admin/mjx/list',
          name: '/admin/mjx/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/mjx/list.vue'], resolve),
        },
        {   
          path: '/admin/mjx/classifly',
          name: '/admin/mjx/classifly',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/mjx/classifly.vue'], resolve),
        },
        {   
          path: '/admin/mjx/detail',
          name: '/admin/mjx/detail',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/mjx/detail.vue'], resolve),
        },
        {   
          path: '/admin/edition/list',
          name: '/admin/edition/list',
          meta:{
            title:'运营后台管理系统'
          },
          component:(resolve) => require(['@/components/edition/list.vue'], resolve),
        },
        {   
          path: '/admin/consult/list',
          name: '/admin/consult/list',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/consult/list.vue'], resolve),
        },
        {   
          path: '/admin/consult/listh',
          name: '/admin/consult/listh',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/consult/listh.vue'], resolve),
        },
        {   
          path: '/admin/tool/list',
          name: '/admin/tool/list',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/list.vue'], resolve),
        },
        {   
          path: '/admin/tool/classify',
          name: '/admin/tool/classify',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/classify.vue'], resolve),
        },
        {   
          path: '/admin/tool/banner',
          name: '/admin/tool/banner',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/banner.vue'], resolve),
        },
        {   
          path: '/admin/tool/user',
          name: '/admin/tool/user',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/user.vue'], resolve),
        },
        {   
          path: '/admin/tool/toolList',
          name: '/admin/tool/toolList',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/toolList.vue'], resolve),
        },
        {   
          path: '/admin/tool/classifyTool',
          name: '/admin/tool/classifyTool',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/classifyTool.vue'], resolve),
        },
        {   
          path: '/admin/tool/addClassifyTool',
          name: '/admin/tool/addClassifyTool',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/addClassifyTool.vue'], resolve),
        },
        {   
          path: '/admin/tool/editorClassifyTool',
          name: '/admin/tool/editorClassifyTool',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/editorClassifyTool.vue'], resolve),
        },
        {   
          path: '/admin/tool/addTool',
          name: '/admin/tool/addTool',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/addTool.vue'], resolve),
        },
        {   
          path: '/admin/tool/editorTool',
          name: '/admin/tool/editorTool',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/editorTool.vue'], resolve),
        },
        {   
          path: '/admin/tool/info',
          name: '/admin/tool/info',
          meta:{
            title:'试用商家咨询列表'
          },
          component:(resolve) => require(['@/components/tool/info.vue'], resolve),
        },
      ]
    }
  ]
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js